/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Link } from "react-router-dom";
import { Cell } from "react-table";
import { ROUTES } from "~/routing/routes";

export type MappedEnvironment = {
  currentMonth: string;
  forecast: string;
  previousMonth: string;
  name: string;
  environment: {
    id: string;
    name: string;
    application: {
      id: string;
      name: string;
    };
  };
};

export const CostResourceSplitPerEnvironmentsList = [
  {
    Header: "Name",
    accessor: "name",
    disableSortBy: true,
    width: "50%",
    Cell: ({ row }: Cell<MappedEnvironment>) => {
      return (
        <Link
          to={`${ROUTES.applications.index}/${row.original.environment.application.id}/${row.original.environment.id}`}
        >
          {row.original.environment.application.name}
          <br />
          {row.original.name}
        </Link>
      );
    },
  },
  {
    Header: "Cost",
    accessor: "currentMonth",
    disableSortBy: true,
    width: "5rem",
  },
  {
    Header: "Previous Month",
    accessor: "previousMonth",
    disableSortBy: true,
    width: "5rem",
  },
  {
    Header: "Monthly Forecast",
    accessor: "forecast",
    disableSortBy: true,
    width: "5rem",
  },
];
